<template>
  <div id="container-interes">
    <form action="#">
      <div class="contenedor_formulario">
        <div class="titulointeres"><span>¿Aún no ha creado sitios de interes?</span></div>
        <div class="container-interno-interes">
          <div><span> La creacíon de un sitio de interés le permite personalizar y realizar un análisis de profundidad del sitio,asi como recibir notificaciones por correo electrónico de cuando hay nuevas alertas de focos de calor disponibles.</span>
          </div>
        </div>
        <div class="contenedor_input">
          <div>
            <label class="typo__label label label-select">Filtros</label>
            <multiselect v-model="filter"
                         :options="filters"
                         label="name"
                         track-by="id"
                         @select="selectFilter"
                         :searchable="false"
                         :show-labels="false"
                         placeholder="Seleccionar"/>
          </div>

          <div v-show="showDepartamento">
            <label class="typo__label label label-select">Departamentos</label>
            <multiselect v-model="departamento"
                         placeholder="Seleccione"
                         selectLabel="Seleccionar"
                         deselectLabel="Quitar"
                         selectedLabel="Selecionado"
                         label="nombre_departamento"
                         track-by="codigo_departamento"
                         :options="departamentos"
                         :multiple="true"
                         :taggable="true"/>

            <label class="typo__label label label-select">Municipios</label>
            <multiselect v-model="municipio"
                         placeholder="Seleccione"
                         selectLabel="Seleccionar"
                         deselectLabel="Quitar"
                         selectedLabel="Selecionado"
                         label="nombre_municipio"
                         track-by="codigo_municipio"
                         :options="municipios"
                         :multiple="true"
                         :taggable="true"/>
          </div>

          <div v-show="showAPNacional">
            <label class="typo__label label label-select">Áreas protegidas nacional</label>
            <multiselect v-model="apNacional"
                         placeholder="Seleccione"
                         selectLabel="Seleccionar"
                         deselectLabel="Quitar"
                         selectedLabel="Selecionado"
                         label="ap_nal"
                         track-by="idap_nal"
                         :options="apNacionales"
                         :multiple="true"
                         :taggable="true"/>
          </div>

          <div v-show="showAPSubNacional">
            <label class="typo__label label label-select">Áreas protegidas SubNacional</label>
            <multiselect v-model="apSubNacional"
                         placeholder="Seleccione"
                         selectLabel="Seleccionar"
                         deselectLabel="Quitar"
                         selectedLabel="Selecionado"
                         label="ap_sub"
                         track-by="codigo_ap_sub"
                         :options="apSubNacionales"
                         :multiple="true"
                         :taggable="true"/>
          </div>

          <div v-show="showDepartamento || showAPNacional || showAPSubNacional">
            <label class="typo__label label label-select">Frecuencia</label>
            <multiselect v-model="frecuencia"
                         :options="frecuencias"
                         selectLabel="Seleccionar"
                         deselectLabel="Quitar"
                         selectedLabel="Selecionado"
                         label="name"
                         track-by="frecuencia"
                         :searchable="false"
                         :show-labels="false"
                         placeholder="Seleccione"/>
          </div>

          <div class="field is-grouped is-grouped-right btn-intereses">
            <button @click="saveSitiosInteres" type="submit" class="button is-primary">Guardar mis sitios</button>
          </div>
        </div>

        <div class="notification is-danger mt-6" v-if="error"> {{ error }} </div>
        <div class="notification is-success mt-6" v-if="success"> {{ success }} </div>
      </div>
    </form>
    <div class="contendor_datos_usuario">
      <div><p class="correo_cuenta">{{ emailUser }}</p></div>
      <div class="closesesion"><a href="#" class="enlace_cerrar" @click="signOut()">Cerrar Sesión</a>
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import firebase from "firebase";
import axios from "axios";
import {config} from '@/config.json'
import * as LocalStorage from "@/helpers/localstorage"
import * as Utils from "@/helpers/utils"
import jsonDepartamentosMunicipios from "@/helpers/departamentos-municipios.json";

export default {
  name: "SitiosInteres",
  components: {
    Multiselect
  },
  data() {
    return {
      filter: [],
      filters: [
        { "id": 1, "name": "Departamentos" },
        { "id": 2, "name": "Áreas protegidas nacional" },
        { "id": 3, "name": "Áreas protegidas subnacional" }
      ],

      frecuencia: null,
      frecuencias: [
        { "name": "2 horas", "frecuencia": 120 },
        { "name": "4 horas", "frecuencia": 240 },
        { "name": "8 horas", "frecuencia": 480 },
        { "name": "12 horas", "frecuencia": 720 },
        { "name": "24 horas", "frecuencia": 1440 }
      ],

      showDepartamento: false,
      departamento: [],
      departamentos: [],
      municipio: [],
      municipios:[],

      showAPNacional: false,
      apNacional: [],
      apNacionales: [],

      showAPSubNacional: false,
      apSubNacional: [],
      apSubNacionales: [],

      emailUser: '',
      error: '',
      success: '',
    }
  },
  methods: {
    selectFilter(filter) {
      let self = this;
      self.success = '';
      self.error = '';
      switch (filter.id) {
        case 1: {
          self.showDepartamento = true;
          self.showAPNacional = false;
          self.showAPSubNacional = false;
          self.loadDepartamento();
          self.loadMunicipio();
          break;
        }
        case 2: {
          self.showDepartamento = false;
          self.showAPNacional = true;
          self.showAPSubNacional = false;
          self.loadAPNacional();
          break;
        }
        case 3: {
          self.showDepartamento = false;
          self.showAPNacional = false;
          self.showAPSubNacional = true;
          self.loadAPSubNacional();
          break;
        }
      }
    },
    loadDepartamento() {
      let self = this;

      self.$root.$emit("app-show-loading", true);
      axios.get(`${config.api.baseURL}/obtenerSitiosInteresDepartamentoWeb/${LocalStorage.getUserId()}`)
          .then(function (response) {
            self.departamento = Utils.fromJSON(response.data.jsonCompleto);
          })
          .catch((err) => {
            console.log("SitiosInteres: ", err)
            self.error = err.error;
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    loadMunicipio() {
      let self = this;
      self.$root.$emit("app-show-loading", true);
      axios.get(`${config.api.baseURL}/obtenerSitiosInteresMunicipioWeb/${LocalStorage.getUserId()}`)
          .then(function (response) {
            self.municipio = Utils.fromJSON(response.data.jsonCompleto);
          })
          .catch((err) => {
            console.log("SitiosInteres: ", err)
            self.error = err.error;
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    loadAPNacional() {
      let self = this;
      self.$root.$emit("app-show-loading", true);
      axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPNacionalWeb/${LocalStorage.getUserId()}`)
          .then(function (response) {
            self.apNacional = Utils.fromJSON(response.data.jsonCompleto);
            console.log("SitiosInteres2: ", self.apNacional)
          })
          .catch((err) => {
            console.log("SitiosInteres: ", err)
            self.error = err.error;
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    loadAPSubNacional() {
      let self = this;
      self.$root.$emit("app-show-loading", true);
      axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPSubNacionalWeb/${LocalStorage.getUserId()}`)
          .then(function (response) {
            self.apSubNacional = Utils.fromJSON(response.data.jsonCompleto);
          })
          .catch((err) => {
            console.log("SitiosInteres: ", err)
            self.error = err.error;
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    signOut() {
      this.$root.$emit("navresponsive-signout", {});
    },
    loadJsonDepartamentos() {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return item.codigo_municipio === '0';
      });
    },
    loadJsonMunicipios(codigosDepartamento) {
      return jsonDepartamentosMunicipios.filter(function (item) {
        return codigosDepartamento.includes(item.codigo_departamento) && item.codigo_municipio > 0
      });
    },
    loadAllData() {
      let self = this;
      self.success = '';
      self.error = '';

      self.$root.$emit("app-show-loading", true);
      //load departamentos, apnacionales, apsubnacionales
      const promiseAPNal = axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPNacionalWeb`);
      const promiseAPSub = axios.get(`${config.api.baseURL}/obtenerSitiosInteresAPSubNacionalWeb`);

      Promise.all([promiseAPNal, promiseAPSub])
          .then(function (values) {
            self.departamentos = self.loadJsonDepartamentos();
            self.municipios = self.loadJsonMunicipios(self.departamentos.map(it => it.codigo_departamento));
            self.apNacionales = Utils.fromJSON(values[0].data.jsonCompleto);
            self.apSubnacionales = Utils.fromJSON(values[1].data.jsonCompleto);
            console.log("SitiosInteres1: ", self.apNacionales)
          })
          .catch((err) => {
            console.log("SitiosInteres: ", err)
            self.error = err.error;
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          })
    },
    saveSitiosInteres() {
      let self = this;
      let sitiosInteres = [];
      let url = "";

      self.success = '';
      self.error = '';
      self.$root.$emit("app-show-loading", true);

      if(self.showDepartamento) {
        url = `${config.api.baseURL}/guardarSitiosInteres`;
        self.departamento.forEach(function (dep) {
          let obj = {
            "id": 0,
            "id_usuario": LocalStorage.getUserId(),
            "codigo_departamento": dep.codigo_departamento,
            "codigo_municipio": dep.codigo_municipio,
            "frecuencia": self.frecuencia.frecuencia
          };
          sitiosInteres.push(obj);
        });

        self.municipio.forEach(function (mun) {
          let obj = {
            "id": 0,
            "id_usuario": LocalStorage.getUserId(),
            "codigo_departamento": mun.codigo_departamento,
            "codigo_municipio": mun.codigo_municipio,
            "frecuencia": self.frecuencia.frecuencia
          };
          sitiosInteres.push(obj);
        });
      } else if (self.showAPNacional) {
        url = `${config.api.baseURL}/guardarSitiosInteresAPNacional`;
        self.apNacional.forEach(function (apNal) {
          let obj = {
            "id": 0,
            "id_usuario": LocalStorage.getUserId(),
            "codigo_ap_nacional": apNal.idap_nal,
            "frecuencia": self.frecuencia.frecuencia
          };
          sitiosInteres.push(obj);
        });
      } else {
        url = `${config.api.baseURL}/guardarSitiosInteresAPSubNacional`;
        self.apSubNacional.forEach(function (apSubNal) {
          let obj = {
            "id": 0,
            "id_usuario": LocalStorage.getUserId(),
            "codigo_ap_subnacional": apSubNal.idap_sub,
            "frecuencia": self.frecuencia.frecuencia
          };
          sitiosInteres.push(obj);
        });
      }

      axios({
        method: 'post',
        url: url,
        data: Utils.toJSON(sitiosInteres),
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
          .then((response) => {
            if (response.data.descripcion === "OK") {
              self.success = "Guardado correctamente";
            } else {
              self.error = response.data.error;
            }
          })
          .catch(error => {
            console.log('SitiosInteres:', error)
            self.error = error;
          })
          .finally(()=>{
            self.$root.$emit("app-show-loading", false);
          });
    }
  },
  mounted() {
    this.emailUser = LocalStorage.getMail();
    //load all selector
    this.loadAllData();
  },
  created() {
    this.$root.$on("sitios-interes-load-data", this.loadAllData);
  },
  beforeDestroy() {
    this.$root.$off("sitios-interes-load-data", this.loadAllData);
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.btn-intereses {
  margin-top: 15px;
}

.enlace_cerrar {
  color: #7C7C7C;
  font-weight: normal;
  text-decoration: underline;
}

#container-interes {
  padding: 30px;
  display: flex;
  overflow-y: hidden;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  height: 100%;
}

.correo_cuenta {
  width: 100%;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 5px 0px 5px 0px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
}

.closesesion {
  font-size: 0.70rem;
}

.contendor_datos_usuario {
  display: block;
  border-top: 2px solid #7C7C7C;
  align-items: center;
}

.contenedor_input {
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.select-input_p {
  width: 89% !important;
}

.select-input_m {
  width: 88% !important;
}

.titulointeres {
  font-weight: 600;
  font-size: 1.20rem;
  width: 80%;
  margin-bottom: 15px;
}

.select select {
  border-radius: 50px !important;
}

.select select:focus, .textarea:focus, .input:focus, .select select.is-focused, .is-focused.textarea, .is-focused.input, .select select:active, .textarea:active, .input:active, .select select.is-active, .is-active.textarea, .is-active.input {
  border-color: #555555;
  color: #8a8a9f;
  box-shadow: 0 0 0 0.1em #555555;
  border-radius: 35px;
}

select {
  color: #555555;
  background-color: white;
  padding: 10px;
  border: 1px solid #e5e5df;
  width: 246px !important;
  border-radius: 35px;
  height: 2em !important;

}

.select {
  width: 90%;
}

.select select {
  width: 100% !important;
  line-height: 0.5 !important;
}

.button.is-primary {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}
</style>